import { Config } from '@leverege/plugin';
function processRelationship(molten, relationship) {
  const {
    attribute,
    blueprint
  } = relationship;
  if (attribute == null && blueprint.hasTag('is:root') && !Config.get('InitialRoute', 'fallbackUrl')) {
    Config.set('InitialRoute', 'fallbackUrl', relationship.urlPath);
  }
}
export default {
  type: 'molten.DefaultInitialRouteCreator',
  processRelationship
};